import { Component } from "react";
import { observer } from "mobx-react";
import { computed } from "mobx";
import { getFetchingManager } from "@matchlighter/fetcher";

import { Mask, MaskProps } from '@instructure/ui-overlays'
import { LoadState } from "@matchlighter/fetcher/lib/base_fetcher";
import { DeclAlert } from "./AlertManager";

interface LoadingMaskProps<T> {
    context: T;
    only?: (keyof T)[]
    except?: (keyof T)[]
}

// InstUI 8 / emotion: apply the component-level theme override via the
// `themeOverride` prop (replaces the themeable `{ [Mask.theme]: {...} }` shape).
export const LowMask = (props: MaskProps) => {
    return <Mask themeOverride={{ zIndex: 10 }} {...props} />
}

@observer
export class LoadingMask<T> extends Component<LoadingMaskProps<T>> {
    getManager() {
        return getFetchingManager(this.props.context);
    }

    countStatuses(statuses: LoadState | LoadState[]) {
        let desiredStates = typeof statuses == 'string' ? [statuses] : statuses;
        const mgr = this.getManager();

        let count = 0;
        for (let k of this.checkedKeys) {
            const f = mgr.fetcherFor(k);
            if (desiredStates.includes(f.valueStatus)) count++;
        }

        return count;
    }

    @computed.struct
    get checkedKeys() {
        const mgr = this.getManager();
        let desKeys = new Set(this.props.only || mgr.fetchedProperties);
        for (let exc of this.props.except || []) {
            desKeys.delete(exc);
        }
        return desKeys;
    }

    @computed
    get lowestState(): LoadState {
        const mgr = this.getManager();

        let state: LoadState = 'loaded';
        for (let k of this.checkedKeys) {
            const f = mgr.fetcherFor(k);
            if (f.valueStatus == 'error') return 'error';
            if (f.valueStatus == 'unloaded') state = 'unloaded';
            if (f.valueStatus == 'loading' && state != 'unloaded') state = 'loading';
        }

        return state;
    }

    render() {
        if (this.lowestState == 'loaded') return null;
        if (this.lowestState == 'error') return (
            <>
                <DeclAlert variant="error" timeout={0}>An Error Occurred While Fetching Data</DeclAlert>
                <LowMask />
            </>
        )
        return <LowMask />
    }
}
